import { PIEVE_LOCAL_ONLY_SETTING_KEYS, PIEVE_SYNCED_SETTING_KEYS, getPievePrefEntriesFromSettingsPatch, getPievePrefKeyFromSettingPath, getPieveSettingPathFromPrefKey, getPieveSettingsPatchFromPrefMap, getPieveSyncedPrefMap, hasPieveSettingsPatchValues, normalizePievePrefEntry, splitPieveSettingsPatchByPersistence } from '@shared/utils';

export const PIEVE_SYNCED_SETTING_PATHS = PIEVE_SYNCED_SETTING_KEYS;
export const PIEVE_LOCAL_ONLY_SETTING_PATHS = PIEVE_LOCAL_ONLY_SETTING_KEYS;

export { getPievePrefEntriesFromSettingsPatch, getPievePrefKeyFromSettingPath, getPieveSettingPathFromPrefKey, getPieveSettingsPatchFromPrefMap, getPieveSyncedPrefMap, hasPieveSettingsPatchValues, normalizePievePrefEntry, splitPieveSettingsPatchByPersistence };

export const getPieveSettingValueFromSettings = ({ settings = {}, settingPath }) => {
  const normalizedPath = String(settingPath || '').trim();

  if (!normalizedPath) {
    return undefined;
  }

  return settings?.[normalizedPath];
};
